import { combineReducers } from 'redux';
import basicDetailsReducer from './basicDetailsReducer';
import assetSecificatonReducer from './assetSpecificationReducer';
import purchaseDetailsReducer from './purchaseDetailsReducer';
import mandatoryFieldsReducer from './mandatoryFieldsReducer';
import attachmentDetailsReducer from './attachmentDetailsReducer';
import gridReducer from './gridReducer';
import authReducer from './AuthendicationReducer/authReducer';
import workorderReportsFilter from './workorderReportsFilter';
import workOrderReducer from './workOrderReducer';
import formSlice from './HospitalInformationReducer/formSlice';
import themeReducer from '../themes/themeSlice';
import historicalCostReducer from './historicalCostReducer';
import workOrderBasicDetailsReducer from './WorkOrderSummaryReducer/workOrderBasicDetailsReducer'
import workOrderMandatoryFieldsReducer from './WorkOrderSummaryReducer/workOrderMandatoryFiledReducer';
import serviceTypeReducer from './serviceTypeReducer';
import testingCommissionReducer from './TestingCommisionReducer/testingCommissionMain';
import stockSlice from './StockRegisterReducer/stockSlice';
import dashboardReducer from './dashboardReducer';
import workorderApiResponseReducer from './WorkOrderSummaryReducer/workorderApiResponseReducer';
import partsRequiredReducer from './WorkOrderSummaryReducer/checkPartsRequiredValueReducer';
import checkPartsRequiredReducer from './WorkOrderSummaryReducer/checkPartsRequiredValueReducer';
import statusChanges from './WorkOrderSummaryReducer/statusChanges';
import assetAnalysisReducer from './assetAnalysisReducer';
import assetAnalysisReportFilter from "./assetAnalysisReportFilter";
import webFormReducer from "./vendor/webFormReducer"
import ScmWorkOrderBasicDetailsReducer from './ScmReducer/ScmWorkOrderBasicDetailsReducer';
import ScmWorkOrderMandatoryFieldsReducer from './ScmReducer/ScmWorkOrderMandatoryFiledReducer';
import ScmCheckPartsRequiredReducer from './ScmReducer/ScmCheckPartsRequiredValueReducer';
import routineInspecMandatoryFieldReducer from './routineInspectionReducer/routineInspecMandatoryFieldReducer';
import routineInspecBasicdetailsReducer from './routineInspectionReducer/routineInspecBasicdetailsReducer';
import routineInspectionWebFormReducer from './vendor/routineInspectionWebFormReducer';
import decryptDatareducers from './WorkOrderSummaryReducer/decryptDataReducers';
import scmWebFormReducer from './vendor/scmWebFormReducer';

const rootReducer = combineReducers({
  basicDetails: basicDetailsReducer,
  workOrderReducer: workOrderReducer,
  workorderfilterDetails: workorderReportsFilter,
  assetSpecification: assetSecificatonReducer,
  purchaseDetails: purchaseDetailsReducer,
  mandatoryFields: mandatoryFieldsReducer,
  gridValues: gridReducer,
  attachmentDetails: attachmentDetailsReducer,
  authendicationReducer: authReducer,
  theme: themeReducer,
  newHisotricalCostData: historicalCostReducer,
  serviceType: serviceTypeReducer,
  form: formSlice,  //HospiRtalInfo
  workOrderBasicDetails: workOrderBasicDetailsReducer,
  hyperLinkData:decryptDatareducers,
  checkParts: checkPartsRequiredReducer,
  scmCheckParts:ScmCheckPartsRequiredReducer,
  workOrdermandatoryFields: workOrderMandatoryFieldsReducer,
  TestingCommissionDetails: testingCommissionReducer,
  stock: stockSlice, //StockRegister
  dashboard: dashboardReducer,
  workorderAPIResponse: workorderApiResponseReducer,
  workOrderStatus: statusChanges,
  assetAnalysisReducer: assetAnalysisReducer,
  assetAnalysisFilterDetails: assetAnalysisReportFilter,
  vendorWebForm: webFormReducer,
  scmBasicDetails: ScmWorkOrderBasicDetailsReducer,
  scmMandatoryFields: ScmWorkOrderMandatoryFieldsReducer,
  routineInspecMandatoryFields:routineInspecMandatoryFieldReducer,
  routineInspecBasicdetails:routineInspecBasicdetailsReducer,
  routineInspectionVendorWebForm:routineInspectionWebFormReducer,
  scmVendorWebForm:scmWebFormReducer
});

export default rootReducer;
